<template>
  <div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="SalesForecastInputAdd"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            "
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                      <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                       &nbsp;&nbsp;&nbsp;
                      <h6 class="card-title mb-0 float-start" style="padding-left: 25px">{{ $t("inputForecastTxt") }}</h6>
                      <button
                        class="btn btn-success btn-xs float-end"
                        @click="downloadData"
                        type="button"
                      >
                      <i class="link-icon" data-feather="download"></i>
                        {{ $t("downloadData") }} Template
                      </button>

               
                </div>
                <div class="card-body">
                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div
                      class="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>
                  <!--end::loading-data-->

                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                    enctype="multipart/form-data"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-between
                        align-items-baseline
                        mb-2
                      "
                    >
                    
                    </div>
                    <!-- <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Business Unit</label
                        >
                      </div>
                      <div class="col-lg-3">
                        <v-select
                          :options="fetchBusinessUnit"
                          v-model="business_unit"
                          label="bu_name"
                          return-object
                          @input="asyncSearchBusinessUnit"
                          :required="!business_unit"
                        ></v-select>
                        <div v-if="errors.bu_id">
                          <div
                            v-for="error in errors.bu_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-1">
                            <label for="defaultconfig" class="col-form-label">Area</label>
                          </div>
                          <div class="col-lg-3">
                        <v-select
                          :options="fetchArea"
                          v-model="area"
                          label="area_name"
                          return-object
                          @input="asyncSearchArea"
                        ></v-select>
                        <div v-if="errors.area_id">
                          <div
                            v-for="error in errors.area_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div> -->
                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">File</label>
                      </div>
                      <div class="col-lg-8">
                       
                        <input type="file" ref="file" class="form-control" @change="handleFileUpload($event)" />

                        <div v-if="errors.code">
                          <div
                            v-for="error in errors.code"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-primary float-end btn-sm"
                        type="submit"
                      >
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>

                  </form>
                </div>
              </div> <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->
        <modal-error :showModal="showmodalDetailError" :data="this.dataModal" @closeModal="closeMyModal">
        </modal-error>
        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import modalDetailError from "@/components/modal/modalDetailError.vue";

export default {
  name: "InputForecastIndex",
  props: {},
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    "modal-error": modalDetailError,
  },
  data() {
    return {
      file: '',
      permision_role:[],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      regionCode: "",
      forms: { name: "", usernmae: "" },
      fetchBusinessUnit: [],
    fetchArea: [],
    business_unit:[],
    area:[],
    showmodalDetailError: false,
      dataModal: {},
    };
  },
  watch: {},
  methods: {
    resetForm() {


    },
    loadBusinessUnit() {
      const baseURI = this.$settings.endPoint + "sales-forecast/bu-forecast?user_id="+this.varuserid;

      return this.$http.get(baseURI).then((response) => {
        this.fetchBusinessUnit = response.data.datas;
      });
    },
    
    asyncSearchBusinessUnit(ev) {
      const baseURI = this.$settings.endPoint + "sales-forecast/bu-filter-forecast?user_id="+this.varuserid +"&bu_name="+ ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchBusinessUnit = response.data.datas;
      });
    },

    loadArea() {
      const baseURI = this.$settings.endPoint +  "sales-forecast/area-forecast?user_id="+this.varuserid;

      return this.$http.get(baseURI).then((response) => {
        this.fetchArea = response.data.datas;
      });
    },

    asyncSearchArea(ev) {
      const baseURI = this.$settings.endPoint + "sales-forecast/area-forecast?user_id="+this.varuserid +"&area_name="+ ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchArea = response.data.datas;
      });
    },

    closeMyModal() {
    
      location.reload();
    this.showmodalDetailError = false;
  },

    handleFileUpload( event ){
      this.file = event.target.files[0];
    },

    downloadData() {
      const baseURI = this.$settings.endPoint + "/sales-forecast/download-input";

      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      //var columnFilters = this.serverParams.columnFilters;


      return this.$http
        .get(
          baseURI + `?user_id=${this.varuserid}`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.loading();
          if (response.data.status == 422) {
            
            this.errors = response.data.errors;
            console.log(response.data);
            this.resultError(response.data.errors);
          }else{
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);}
        }).catch((error) => {
          this.loading();
      
          if (error.response) {
            if (error.response.status == 422) {
              return this.$http
              .get(
                baseURI + `?user_id=${this.varuserid}`
              
              )
              .catch((error) => {
                if (error.response) {
                  if (error.response.status === 422){
                    this.errors = error.response.data.errors;
                 
                  this.resultError(error.response.data.errors);
                  }
                }
              });
             
              // console.log( this.resultError );
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
          //this.resetForm();
        });
    },


    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.detailUser     = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      let varuserid =[];
      varuserid =userDatas.sub.user_id;
      userDatas.sub.permision_role.forEach(function(permision){
        
        if(permision.permission.controller == 'SalesForecastController'){
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if(!rolePermision.method_upload){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    this.varuserid=varuserid;

    },

    backForm() {
       window.location.href = "/input-forecast";
    },


    submitData() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourData"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.fade(true);

          let formData = new FormData();
        
          formData.append("file", this.file);
          formData.append("user_id", this.varuserid);
          // formData.append("bu_id", this.business_unit.bu_id);
          // formData.append("area_id", this.area.area_id);
         
          const baseURI  =  this.$settings.endPoint+"sales-forecast/upload-forecast";
          this.$http.post(baseURI,formData).then((response) => {
              this.loading();
              if(response.data.status === 200) {
              this.resetForm();
              this.errors = [];
                  //console.log(response.data.datas.user_id);
                  //var params = this.$onRandom(response.data.datas.region_id);
                  window.location.href = "/input-forecast";
                  // this.success('Berhasil');
              }else{
                  this.errors = response.data.errors;
                  this.resultError(response.data.errors);
              }
          }).catch(error => {
              this.loading();
              if (error.response) {
              if(error.response.status === 422) {
           
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
              }else if (error.response.status === 420) {
                
                  this.showmodalDetailError = true;
                    this.dataModal = error.response.data.errors
                    
                }
              else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else{
                  this.$router.push('/page-not-found');
              }
              }
              this.resetForm();
          });
        }
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loadBusinessUnit();
    this.loadArea();
  },
};
</script>
<style scoped>
</style>